module.exports = __webpack_public_path__ + "img/98.521ee820.svg";